import { CommonEnums } from '../common.enums';

export class Layer {
	layer_Id: number;
	fldr_Id: number;
	nm: string;
	description: string;
	srt_Order: number;
	updateDt: Date;
	updateBy: string;
	lastUpdateBy: string;
	change_Ind: string;

	constructor() {
		this.setDefaults();
	}

	setDefaults() {
		this.layer_Id = CommonEnums.defaults.LONG_VAL;
		this.fldr_Id = CommonEnums.defaults.LONG_VAL;
		this.nm = CommonEnums.defaults.STRING_EMPTY;
		this.description = CommonEnums.defaults.STRING_EMPTY;
		this.srt_Order = CommonEnums.defaults.LONG_VAL;
		this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
		this.updateDt = new Date();
		this.updateBy = CommonEnums.defaults.STRING_EMPTY;
		this.change_Ind = CommonEnums.change_Ind.NO_CHANGE
	}

	static parse(object: any): Layer {   // Constant method that is the same for every instance of a class.
		let layer: Layer = new Layer();
		layer.copyFrom(object as Layer);
		return layer;
	}
	copy(): Layer {
		let layerTmp: Layer = new Layer();
		layerTmp.layer_Id = this.layer_Id;
		layerTmp.fldr_Id = this.fldr_Id;
		layerTmp.nm = this.nm;
		layerTmp.description = this.description;
		layerTmp.srt_Order = this.srt_Order;
		layerTmp.lastUpdateBy = this.lastUpdateBy;
		layerTmp.updateDt = this.updateDt;
		layerTmp.updateBy = this.updateBy;
		layerTmp.change_Ind = this.change_Ind;
		return layerTmp;
	}
	copyFrom(layerTemp: Layer): void {
		this.layer_Id = layerTemp.layer_Id;
		this.fldr_Id = layerTemp.fldr_Id;
		this.nm = layerTemp.nm;
		this.description = layerTemp.description;
		this.srt_Order = layerTemp.srt_Order;
		this.lastUpdateBy = layerTemp.lastUpdateBy;
		this.updateDt = layerTemp.updateDt;
		this.updateBy = layerTemp.updateBy;
		this.change_Ind = layerTemp.change_Ind;

	}
	compare(layerTemp: Layer): string {
		let layerString: string = this.toString(false);
		let layerTmpString: string = layerTemp.toString(false);

		if (layerString != layerTmpString) {
			return layerString + ', ' + layerTmpString;
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "Layer [layer_Id=" + this.layer_Id + ", fldr_Id=" + this.fldr_Id + ", nm=" + this.nm + ", description=" + this.description
			+ ", srt_Order=" + this.srt_Order + ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy
			+ ", lastUpdateBy=" + this.lastUpdateBy;
		if (isNotCompare) {
			str += ", change_Ind=" + this.change_Ind;
		}
		str += ']';
		return str;
	}
}



